export default __webpack_public_path__ + "static/media/echappe.07e40e20.svg";